import { DEFAULT_MEDIA_QUERY_PLATFORMS, COMPONENT_STATES, COMPONENT_TYPE as TYPE, Pin } from 'common/constants';
import View from 'client/components/common/BuildingBlocks/Answer/ResultText/ResultText';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';

/**
 * @param options {Object=}
 * @param options.dictionary {Object=}
 * @returns {{ view, model }}
 * @constructor
 */
export const RESULT_TEXT = (options = {}) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.RESULT_TEXT;

			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: RESULT_TEXT.displayName,
						selectable: true,
						draggable: false,
						expandable: false,
						expanded: false,
					},
					nodeProps: {
						id: generateNodeId(_id, RESULT_TEXT.displayName),
					},
					componentProps: {
						styles: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									left: '1.17vw',
									top: '-2.19vw',
									right: 'auto',
									bottom: 'auto',
								},
							},
						},
						other: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									pinType: Pin.lb,
								},
							},
						},
					},
				},
				children: [],
			};
		},
	};
};

RESULT_TEXT.displayName = 'ResultText';
